
export const LoadStatus = {
  YAYINDA: 'YAYINDA',
  TEKLIF_ALDI: 'TEKLIF_ALDI',
  TEKLIF_BEKLIYOR: 'TEKLIF_BEKLIYOR',
  TEKLIF_KABUL_EDILDI: 'TEKLIF_KABUL_EDILDI',
  IPTAL_EDILDI: 'IPTAL_EDILDI',
  YUKLENIYOR: 'YUKLENIYOR',
  YUKLENDI: 'YUKLENDI',
  YOLDA: 'YOLDA', 
  TESLIM_EDILDI: 'TESLIM_EDILDI',
  DEGERLENDIRME_BEKLIYOR: 'DEGERLENDIRME_BEKLIYOR'
};

export const OfferStatus = {
  BEKLEMEDE: 'BEKLEMEDE',
  KABUL_EDILDI: 'KABUL_EDILDI',
  YOLDA: 'YOLDA', 
  REDDEDILDI: 'REDDEDILDI',
  TAMAMLANDI: 'TAMAMLANDI'
};